import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { deleteAdd, listeAdds } from '../../actions/advertisingActions'
import { deleteJob, listeJobs } from '../../actions/jobsAxctions'
import LIstJobsView from '../../containers/Advertising/ListAdvertising/ListAdvertising'

const ListAdvertising = () => {
    const dispatch = useDispatch()
    const {adds} = useSelector(state=>state.advertinsingReducers)
    useEffect(() => {
      dispatch(listeAdds())
    
      return () => {
        
      }
    }, [])
    const deleteJobFn = (id,close)=>{
      dispatch(deleteAdd(id,close))
    }
  return (
    <LIstJobsView jobs={adds} deleteJob={deleteJobFn}/>
  )
}

export default ListAdvertising